import { BaseEntity, getCachedConstellationEntity } from ".";

export class RegionEntity extends BaseEntity {
  constructor(id: number, props: any) {
    super(id, props);
    this._dataTypeName = "Region";
  }

  async toJson(): Promise<Excel.EntityCellValue> {
    //const id = this._id;
    const props = this.props;

    var entity = await super.toJson();

    // Properties
    if (entity.properties) {
      // - Data Type
      entity.properties["data_type"] = {
        type: Excel.CellValueType.string,
        basicValue: "Region",
      };
      if (props.constellationIDs) {
        let constellation_array: Excel.CellValue[][] = [];
        for (const y of props.constellationIDs) {
          const entity = await getCachedConstellationEntity(y);
          if (entity !== null) {
            const resolvedEntity = await entity.toJson();
            constellation_array.push([resolvedEntity]);
          } else {
            constellation_array.push([
              {
                type: Excel.CellValueType.entity,
                text: y.toString(),
                properties: {
                  id: {
                    type: Excel.CellValueType.double,
                    basicValue: y,
                  },
                },
              },
            ]);
          }
        }
        if (constellation_array.length) {
          entity.properties["constellations"] = {
            type: Excel.CellValueType.array,
            elements: constellation_array,
          };
        }
      }
      entity.text = "Region";
      // - Name
      if (props.name) entity.text = props.name.en;
    }
    // Layouts
    entity.layouts = {
      card: {
        //title: { property: "name" },
      },
      compact: {
        icon: "Atom",
      },
    };

    return entity;
  }
}
